module.exports = __webpack_public_path__ + "img/Infobulle 2.dc80a653.svg";